import { render, staticRenderFns } from "./SiteHead.vue?vue&type=template&id=6264c553&scoped=true&"
import script from "./SiteHead.vue?vue&type=script&lang=js&"
export * from "./SiteHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6264c553",
  null
  
)

export default component.exports